webpackJsonp([272611712033690],{

/***/ 1962:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	__webpack_require__(1962);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fp = __webpack_require__(11);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	// STYLE 
	var query = exports.query = '** extracted graphql fragment **';
	
	// COMPONENTS
	
	
	// LIBS
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var authors = (0, _fp.map)((0, _fp.get)('node'), (0, _fp.get)('allAuthorJson.edges', data));
	  return _react2.default.createElement(
	    'div',
	    { className: 'author', style: { paddingTop: '80px', textAlign: 'center' } },
	    _react2.default.createElement(_metaData2.default, { data: {
	        slug: 'blog/author',
	        title: 'Blog Authors',
	        description: 'Code Fellows blog authors'
	      } }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      ' Blog Authors '
	    ),
	    authors.map(function (author, i) {
	      var image = (0, _fp.get)('image.fields.file.url', author);
	      return _react2.default.createElement(
	        'div',
	        { key: i },
	        _react2.default.createElement(
	          'a',
	          { href: '/' + author.slug },
	          author.name
	        )
	      );
	    })
	  );
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-author-index-js-06b75ee19ded41a46df1.js